@if(showDates)
{
    <div class="row">
        <div class="col-sm-2">
            <h6>Start</h6>
            <ep-datetime-picker
                type="date"
                [readonly]="readonly"
                [(selectedDatetime)]="scheduleItem.StartDate"
                (selectedDatetimeChange)="onStartDateChanged()"
                [required]="true"
                #startdatepicker>
            </ep-datetime-picker>
        </div>

        <div class="col-sm-2">
            <h6>Expire (optional)</h6>
            <ep-datetime-picker
                type="date"
                [readonly]="readonly"
                [(selectedDatetime)]="scheduleItem.EndDate"
                (selectedDatetimeChange)="onEndDateChanged()"
                [required]="false"
                #enddatepicker>
            </ep-datetime-picker>
        </div>
    </div>

    @if(dateRangeError)
    {
        <div class="row">
            <div class="col-sm-4">
                <div class="error">{{ dateRangeError }}</div>
            </div>
        </div>
    }
}

<div class="row">
    <div class="col-sm-2 col-sm-offset-10">
        <button type="button" class="btn btn-link pull-right" (click)="addTrigger()" [disabled]="readonly" title="Add trigger">
            <span>Add Trigger Period</span>
            <ep-svg-icon icon="plus" />
        </button>
    </div>
</div>
<hr />

@for (trigger of scheduleItem.Triggers; track trigger)
{
    <app-trigger-item [readonly]="readonly" [trigger]="trigger" [hideTriggerStart]="hideTriggerStart"
        [hideTriggerEnd]="hideTriggerEnd" [requireWeekdaySelection]="requireWeekdaySelection"
        [validateTriggerTimes]="validateTriggerTimes" (triggerChange)="triggerChange()"
        (triggerRemove)="removeTrigger($event)">
    </app-trigger-item>
}

@if(requireAtLeastOneTrigger)
{
    <div class="error">At least one trigger is required.</div>
}
